import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazyRetry } from '@utils/lazyRetry';
import RequirePermission from '../settings/RequirePermission';

const WorkflowsApp = lazyRetry(() => import('./WorkflowsApp'));

/**
 * The WorkflowsAppRoute - requires SuperAdmin OR "Edit Workflows" permission
 */
const WorkflowsAppRoute: FuseRouteItemType = {
  path: 'admin/workflows',
  children: [
    {
      path: '',
      element: (
        <RequirePermission permission="hasAddWorkflows">
          <WorkflowsApp to="all" />
        </RequirePermission>
      )
    }
  ]
};

export default WorkflowsAppRoute;
